import { slideLabel } from "./projection";

export default function VerseRail({ slides, index, onGo }) {
  return (
    <div className="space-y-2" data-testid="verse-rail">
      {slides.map((s, i) => (
        <button key={i} onClick={() => onGo(i)} data-testid={`verse-${i}`} aria-current={i === index ? "true" : undefined}
          className={`hymn-protect w-full text-left rounded-lg p-3 border transition-colors select-none ${i === index ? "border-[#D4AF37] bg-[#D4AF37]/10" : "border-white/5 bg-white/[0.02] hover:border-white/20"}`}>
          <div className="flex justify-between text-[10px] tracking-widest uppercase mb-1">
            <span className={s.kind === "chorus" ? "text-sky-300" : "text-[#D4AF37]"}>{slideLabel(s)}</span>
            <span className="text-neutral-600">{i < 9 ? `key ${i + 1}` : ""}</span>
          </div>
          <div className="text-xs text-neutral-300 line-clamp-2 whitespace-pre-line">{s.text}</div>
        </button>
      ))}
    </div>
  );
}
